import { EnrollmentStatus } from '@sulis-liiga/common';

/**
 * Shared presentation for an enrollment's lifecycle status. A single place for
 * the label + Tailwind text color keeps the team-facing lists (TeamDetailPage,
 * ProfilePage) and the admin queue view (ManageDivisionsPage) in sync.
 */
const STATUS_LABELS: Record<EnrollmentStatus, string> = {
  [EnrollmentStatus.QUEUED]: 'Queued',
  [EnrollmentStatus.PENDING_PLACEMENT]: 'Pending placement',
  [EnrollmentStatus.ACTIVE]: 'Active',
  [EnrollmentStatus.WITHDRAWN]: 'Withdrawn',
  [EnrollmentStatus.COMPLETED]: 'Completed',
};

const STATUS_CLASS_NAMES: Record<EnrollmentStatus, string> = {
  [EnrollmentStatus.QUEUED]: 'text-blue-700',
  [EnrollmentStatus.PENDING_PLACEMENT]: 'text-yellow-700',
  [EnrollmentStatus.ACTIVE]: 'text-success-700',
  [EnrollmentStatus.WITHDRAWN]: 'text-gray-400',
  [EnrollmentStatus.COMPLETED]: 'text-gray-500',
};

/** Human-readable label for an enrollment's status. */
export function enrollmentStatusLabel(status: EnrollmentStatus): string {
  return STATUS_LABELS[status] ?? status;
}

/** Tailwind text-color class for an enrollment's status. */
export function enrollmentStatusClassName(status: EnrollmentStatus): string {
  return STATUS_CLASS_NAMES[status] ?? 'text-gray-400';
}
